import { render, staticRenderFns } from "./LevelUpPublic_2021_08_12.vue?vue&type=template&id=4cebcf8b&scoped=true&"
import script from "./LevelUpPublic_2021_08_12.vue?vue&type=script&lang=js&"
export * from "./LevelUpPublic_2021_08_12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cebcf8b",
  null
  
)

export default component.exports